import { useAutoLogout } from '@/hooks/useAutoLogout';
import { useAuth } from '@/hooks/useAuth';
import { useAnalytics } from '@/hooks/useAnalytics';

interface AutoLogoutWrapperProps {
  children: React.ReactNode;
}

const AutoLogoutWrapper = ({ children }: AutoLogoutWrapperProps) => {
  const { user } = useAuth();
  const { trackEvent } = useAnalytics();

  const handleLogout = () => {
    // Track logout event
    trackEvent('auto_logout', 'session', 'inactivity_timeout');
  };

  // Configurar auto-logout apenas para usuários autenticados
  useAutoLogout({
    timeoutMinutes: 30, // 30 minutos de inatividade
    warningMinutes: 5,  // Aviso 5 minutos antes
    onLogout: handleLogout
  });

  return <>{children}</>;
};

export default AutoLogoutWrapper;
